import { forwardRef } from 'react';
import { PatternFormat as NumberFormat } from 'react-number-format';
import type { InputFormatProps } from '../types';

const ZipCodeFormat = forwardRef<HTMLInputElement, InputFormatProps>(({ field }, ref) => {
  const { onChange, value, ...rest } = field;
  return (
    <NumberFormat
      value={value}
      {...rest}
      getInputRef={ref}
      className='block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm placeholder-gray-300 focus:outline-hidden'
      format='#####'
      valueIsNumericString
      onValueChange={(target) => {
        onChange(target.formattedValue);
      }}
    />
  );
});

export default ZipCodeFormat;
